/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface SetEmployeeRolesResponse
 */
export interface SetEmployeeRolesResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof SetEmployeeRolesResponse
     */
    userId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof SetEmployeeRolesResponse
     */
    accountCreated: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof SetEmployeeRolesResponse
     */
    roles: Array<string>;
}

/**
 * Check if a given object implements the SetEmployeeRolesResponse interface.
 */
export function instanceOfSetEmployeeRolesResponse(value: object): value is SetEmployeeRolesResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('accountCreated' in value) || value['accountCreated'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function SetEmployeeRolesResponseFromJSON(json: any): SetEmployeeRolesResponse {
    return SetEmployeeRolesResponseFromJSONTyped(json, false);
}

export function SetEmployeeRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetEmployeeRolesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': ApiUserTasksGetPageParameterFromJSON(json['userId']),
        'accountCreated': json['accountCreated'],
        'roles': json['roles'],
    };
}

export function SetEmployeeRolesResponseToJSON(json: any): SetEmployeeRolesResponse {
    return SetEmployeeRolesResponseToJSONTyped(json, false);
}

export function SetEmployeeRolesResponseToJSONTyped(value?: SetEmployeeRolesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': ApiUserTasksGetPageParameterToJSON(value['userId']),
        'accountCreated': value['accountCreated'],
        'roles': value['roles'],
    };
}

